/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnWhyCheckPlus.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnWhyCheckPlus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnWhyCheckPlus-view">
        <Helmet>
          <title>为什么选择 CheckPlus？ - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}
        {renderHomePageHeader(this)}

        <div className="CnWhyCheckPlus-first">
          <div className="CnWhyCheckPlus-heading">为什么选择 CheckPlus？</div>
          <div className="CnWhyCheckPlus-scrollContainer">
            <div className="CnWhyCheckPlus-space">
              <div className="CnWhyCheckPlus-centerContent" />
            </div>
            <div className="CnWhyCheckPlus-box">
              <div className="CnWhyCheckPlus-centerContent">
                <div className="CnWhyCheckPlus-CheckPlusLogoCircle">
                  <div className="CnWhyCheckPlus-CheckPlusLogo" />
                </div>

                <div className="CnWhyCheckPlus-logoTxt">CheckPlus</div>
                <div className="CnWhyCheckPlus-list">
                  + 每月低至 HK$150 <p />+ 多种功能 <p />+ 简单使用
                </div>
              </div>
            </div>
            <div className="CnWhyCheckPlus-box">
              <div className="CnWhyCheckPlus-centerContent">
                <div className="CnWhyCheckPlus-developerIcn" />

                <div className="CnWhyCheckPlus-developerTxt">
                  雇用软件开发人员
                </div>
                <div className="CnWhyCheckPlus-list">
                  - 开发成本昂贵和维护费用 (每月$2-20k) <p />- 开发时间长 <p />-
                  潜在系统问题
                </div>
              </div>
            </div>
            <div className="CnWhyCheckPlus-box">
              <div className="CnWhyCheckPlus-centerContent">
                <div className="CnWhyCheckPlus-banksIcn" />

                <div className="CnWhyCheckPlus-developerTxt">
                  银行或支付网关
                </div>
                <div className="CnWhyCheckPlus-list">
                  - 功能不足 <p />- 耗时的管理 <p />- 不容易操作
                </div>
              </div>
            </div>
            <div className="CnWhyCheckPlus-space2">
              <div className="CnWhyCheckPlus-centerContent" />
            </div>
          </div>
        </div>
        <div className="CnWhyCheckPlus-content">
          <div className="CnWhyCheckPlus-checkplusCircle" />
          <div className="CnWhyCheckPlus-heading">我们如何设计 CheckPlus？</div>
          <div className="CnWhyCheckPlus-subheading">
            CheckPlus 拥有自己的开发人员团队，并与 Stripe、PayPal 和 汇丰
            合作去建立平台。
          </div>
        </div>

        <div className="CnWhyCheckPlus-second">
          <div className="CnWhyCheckPlus-heading CnWhyCheckPlus-whiteTxt">
            CheckPlus 功能
          </div>
        </div>

        <div className="CnWhyCheckPlus-first">
          <div className="CnWhyCheckPlus-content">
            <div className="CnWhyCheckPlus-heading">1. 建立捐款网页</div>
            <div className="CnWhyCheckPlus-subheading">
              透过 CheckPlus，系统会自动为阁下的机构准备一个捐款网页。
            </div>
            <div className="CnWhyCheckPlus-feature1" />
            <div className="CnWhyCheckPlus-heading">2. 收集捐款者资料</div>
            <div className="CnWhyCheckPlus-subheading">
              CheckPlus 不仅会收集付款信息，还会收集付款者/捐款者数据。
            </div>
            <div className="CnWhyCheckPlus-feature2" />
            <div className="CnWhyCheckPlus-heading">3. 接受多个付款方式</div>
            <div className="CnWhyCheckPlus-subheading">
              付款者/捐款者会看到以下付款方式。
            </div>
            <div className="CnWhyCheckPlus-CC" />
            <div className="CnWhyCheckPlus-ApplePay" />
            <div className="CnWhyCheckPlus-GooglePay" />
            <div className="CnWhyCheckPlus-paymeBtn" />

            <div className="CnWhyCheckPlus-subtitle">即将支援</div>
            <div className="CnWhyCheckPlus-FPS" />
            <div className="CnWhyCheckPlus-paypal" />
            <div className="CnWhyCheckPlus-manualContainer">
              <div className="CnWhyCheckPlus-alipay" />
              <div className="CnWhyCheckPlus-wechatpay" />
              <div className="CnWhyCheckPlus-octopus" />
            </div>
            <div className="CnWhyCheckPlus-manualContainer">
              <div className="CnWhyCheckPlus-bankTransfer"></div>
              <div className="CnWhyCheckPlus-check" />
            </div>

            <div className="CnWhyCheckPlus-heading4">4. 设定付款或捐款类型</div>
            <div className="CnWhyCheckPlus-subheading">
              机构可以设定付款或捐款类型，以确保系统自动发出正确合规格的收据。
            </div>
            <div className="CnWhyCheckPlus-feature4" />
            <div className="CnWhyCheckPlus-heading4">
              5. 自动付款及捐款收据处理
            </div>
            <div className="CnWhyCheckPlus-subheading">
              系统会即时自动处理捐款收据及发送至捐款者所提供的电邮地址。
            </div>
            <div className="CnWhyCheckPlus-feature5" />
            <div className="CnWhyCheckPlus-heading">6. 支援每月定期捐款</div>
            <div className="CnWhyCheckPlus-feature6" />
            <div className="CnWhyCheckPlus-heading4">7. 捐款者户口</div>
            <div className="CnWhyCheckPlus-feature7"></div>

            <div className="CnWhyCheckPlus-heading">8. 自动准备报告</div>
            <div className="CnWhyCheckPlus-feature8" />
          </div>
        </div>

        <div className="CnWhyCheckPlus-section5">
          <div className="CnWhyCheckPlus-verticalLogo" />
          <div className="CnWhyCheckPlus-txt CnWhyCheckPlus-description5">
            立即登记 CheckPlus
          </div>
          <Link to="/OrgLogin">
            <div className="CnWhyCheckPlus-first-bar">立即登记</div>
          </Link>
        </div>

        <div className="CnWhyCheckPlus-footer">
          <div className="CnWhyCheckPlus-footerNav">
            <Link to="/CnTeam">
              <div className="CnWhyCheckPlus-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnWhyCheckPlus-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnWhyCheckPlus-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnWhyCheckPlus-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnWhyCheckPlus-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnWhyCheckPlus-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnWhyCheckPlus;
